import {call, fork, put} from "redux-saga/effects";
import {gzip} from "pako";
import {endMetric, startMetric} from "../../store/log/performance";
import {trackError} from "../../store/log/actions";
import {LogLevel} from "../../store/log/types";

export function* compress(content: any, level: -1 | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9, trackPerformance: boolean = true) {
    if (!content)
        return;

    const metricId = trackPerformance
        ? yield call(startMetric, "gzipEncoder", "encode")
        : 0;

    try {
        const bodyBytes = new TextEncoder().encode(content);
        return gzip(bodyBytes, { level });
    }
    catch (error) {
        yield put(trackError({
            logLevel: LogLevel.Warn,
            category: "Compress",
            message: "Failed to gzip content",
            error: error,
            data: {
                source: content,
                level: level,
            }
        }));

        return content;
    }
    finally {
        if (trackPerformance) {
            yield fork(endMetric, metricId);
        }
    }
}